import React, { useState } from "react";
import { useNavigate } from "react-router";
import {
  Box,
  Button,
  Typography,
  Grid,
  Container,
  Checkbox,
  FormControlLabel,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";

const StartAssessment = ({ onAssessmentBegin }) => {
  const [isChecked, setIsChecked] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const isMedium = useMediaQuery(theme.breakpoints.down("xl"));
  const navigate = useNavigate();

  const { t } = useTranslation("startAssessment");
  const currentLanguage = i18n.language;

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const onAssessmentBeginClick = () => {
    if (assessmentId) {
      navigate(`/assessment/${assessmentId}`, {
        state: { fromDashboard: true, language: currentLanguage },
      });
    } else {
      console.error("Assessment ID is undefined");
    }
  };

  return (
    <Container
      maxWidth="100%"
      sx={{ paddingLeft: "0 !important", paddingRight: "0 !important" }}
    >
      <Box display="flex" className="main-content" flexDirection="column">
        <Box
          display="flex"
          flexDirection="column"
          pl={isMobile ? 0 : 8}
          pt={4}
          pb={isMobile ? 0 : 2}
        >
          <Typography
            variant="h2"
            gutterBottom
            color="secondary"
            fontWeight={400}
            textAlign={isMobile ? "center" : "left"}
          >
            {t("welcome")}
          </Typography>
          <Typography variant="body1" textAlign={isMobile ? "center" : "left"}>
            {t("instructions")}
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection={isMobile ? "column-reverse" : "row"}
          pl={isMobile ? 0 : 8}
          pt={isMobile ? 0 : 4}
          pb={2}
        >
          <Box
            display="flex"
            flexDirection="column"
            mb={3}
            gap={4}
            width={isMobile ? "100%" : "60%"}
          >
            {/* <Box
              display="flex"
              alignItems="center"
              flexDirection="row"
              gap={1}
              justifyContent={isMobile ? "center" : "flex-start"}
            >
              <svg
                width="49"
                height="49"
                viewBox="0 0 49 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="24.5" cy="24.5" r="24.5" fill="#0E89BC" />
                <path
                  d="M34.2463 19.1288L29.8713 14.7538C29.7895 14.6727 29.6925 14.6085 29.5859 14.565C29.4793 14.5214 29.3652 14.4993 29.25 14.5H15.25C14.7859 14.5 14.3408 14.6844 14.0126 15.0126C13.6844 15.3408 13.5 15.7859 13.5 16.25V33.75C13.5 34.2141 13.6844 34.6593 14.0126 34.9875C14.3408 35.3156 14.7859 35.5 15.25 35.5H32.75C33.2141 35.5 33.6592 35.3156 33.9874 34.9875C34.3156 34.6593 34.5 34.2141 34.5 33.75V19.75C34.5007 19.6349 34.4786 19.5207 34.4351 19.4141C34.3915 19.3075 34.3273 19.2105 34.2463 19.1288ZM20.5 16.25H27.5V19.75H20.5V16.25ZM27.5 33.75H20.5V26.75H27.5V33.75ZM29.25 33.75V26.75C29.25 26.2859 29.0656 25.8408 28.7374 25.5126C28.4092 25.1844 27.9641 25 27.5 25H20.5C20.0359 25 19.5908 25.1844 19.2626 25.5126C18.9344 25.8408 18.75 26.2859 18.75 26.75V33.75H15.25V16.25H18.75V19.75C18.75 20.2141 18.9344 20.6593 19.2626 20.9875C19.5908 21.3156 20.0359 21.5 20.5 21.5H27.5C27.9641 21.5 28.4092 21.3156 28.7374 20.9875C29.0656 20.6593 29.25 20.2141 29.25 19.75V16.6088L32.75 20.1088V33.75H29.25Z"
                  fill="white"
                />
              </svg>
              <Typography variant="body1" maxWidth={isMobile ? 260 : 800}>
                <b>{t("save.title")}:</b> {t("save.text")}
              </Typography>
            </Box> */}
            <Box
              display="flex"
              alignItems="center"
              flexDirection="row"
              gap={1}
              justifyContent={isMobile ? "center" : "flex-start"}
            >
              <svg
                width="49"
                height="49"
                viewBox="0 0 49 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="24.5" cy="24.5" r="24.5" fill="#0E89BC" />
                <g clipPath="url(#clip0_348_4564)">
                  <path
                    d="M32.1667 29.1883L30.5217 30.8333L26.3333 26.645L22.145 30.8333L20.5 29.1883L24.6883 25L20.5 20.8117L22.145 19.1667L26.3333 23.355L30.5217 19.1667L32.1667 20.8117L27.9783 25L32.1667 29.1883ZM35.6667 14.5C36.2855 14.5 36.879 14.7458 37.3166 15.1834C37.7542 15.621 38 16.2145 38 16.8333V33.1667C38 33.7855 37.7542 34.379 37.3166 34.8166C36.879 35.2542 36.2855 35.5 35.6667 35.5H18.1667C17.3617 35.5 16.7317 35.08 16.3117 34.4617L10 25L16.3117 15.5267C16.7317 14.9083 17.3617 14.5 18.1667 14.5H35.6667ZM35.6667 16.8333H18.1667L12.66 25L18.1667 33.1667H35.6667V16.8333Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_348_4564">
                    <rect
                      width="28"
                      height="28"
                      fill="white"
                      transform="translate(10 11)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <Typography variant="body1" maxWidth={isMobile ? 250 : isMedium ? 400 : 600}>
                <b>{t("noChange.title")}:</b> {t("noChange.text")}
              </Typography>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              flexDirection="row"
              gap={1}
              justifyContent={isMobile ? "center" : "flex-start"}
            >
              <svg
                width="49"
                height="49"
                viewBox="0 0 49 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="24.5" cy="24.5" r="24.5" fill="#0E89BC" />
                <path
                  d="M20.5 14.5003V12.167H27.5V14.5003H20.5ZM22.8333 27.3337H25.1667V20.3337H22.8333V27.3337ZM24 36.667C22.5611 36.667 21.2047 36.3901 19.9307 35.8363C18.6567 35.2825 17.5437 34.5289 16.5917 33.5753C15.6397 32.6218 14.8864 31.5084 14.3318 30.2352C13.7773 28.9619 13.5 27.6059 13.5 26.167C13.5 24.7281 13.7773 23.3717 14.3318 22.0977C14.8864 20.8237 15.6397 19.7107 16.5917 18.7587C17.5437 17.8067 18.6571 17.0534 19.9318 16.4988C21.2066 15.9443 22.5627 15.667 24 15.667C25.2056 15.667 26.3625 15.8614 27.4708 16.2503C28.5792 16.6392 29.6194 17.2031 30.5917 17.942L32.225 16.3087L33.8583 17.942L32.225 19.5753C32.9639 20.5475 33.5278 21.5878 33.9167 22.6962C34.3056 23.8045 34.5 24.9614 34.5 26.167C34.5 27.6059 34.2227 28.9623 33.6682 30.2363C33.1136 31.5103 32.3603 32.6233 31.4083 33.5753C30.4563 34.5273 29.3429 35.281 28.0682 35.8363C26.7934 36.3917 25.4373 36.6685 24 36.667ZM24 34.3337C26.2556 34.3337 28.1806 33.5364 29.775 31.942C31.3694 30.3475 32.1667 28.4225 32.1667 26.167C32.1667 23.9114 31.3694 21.9864 29.775 20.392C28.1806 18.7975 26.2556 18.0003 24 18.0003C21.7444 18.0003 19.8194 18.7975 18.225 20.392C16.6306 21.9864 15.8333 23.9114 15.8333 26.167C15.8333 28.4225 16.6306 30.3475 18.225 31.942C19.8194 33.5364 21.7444 34.3337 24 34.3337Z"
                  fill="white"
                />
              </svg>
              <Typography variant="body1" maxWidth={isMobile ? 250 : isMedium ? 400 : 600}>
                <b>{t("timeLimit.title")}:</b> {t("timeLimit.text")}
              </Typography>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              flexDirection="row"
              gap={1}
              justifyContent={isMobile ? "center" : "flex-start"}
            >
              <svg
                width="49"
                height="49"
                viewBox="0 0 49 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="24.5" cy="24.5" r="24.5" fill="#0E89BC" />
                <path
                  d="M32.1667 14.5H15.8333C14.55 14.5 13.5 15.55 13.5 16.8333V33.1667C13.5 34.45 14.55 35.5 15.8333 35.5H32.1667C33.45 35.5 34.5 34.45 34.5 33.1667V16.8333C34.5 15.55 33.45 14.5 32.1667 14.5ZM32.1667 33.1667H15.8333V16.8333H32.1667V33.1667ZM18.1667 22.6667H20.5V30.8333H18.1667V22.6667ZM22.8333 19.1667H25.1667V30.8333H22.8333V19.1667ZM27.5 26.1667H29.8333V30.8333H27.5V26.1667Z"
                  fill="white"
                />
              </svg>
              <Typography variant="body1" maxWidth={isMobile ? 250 : isMedium ? 400 : 600}>
                <b>{t("assessmentPurpose.title")}:</b> {t("assessmentPurpose.text")}
              </Typography>
            </Box>
          </Box>
          <Box
            width={isMobile ? "100%" : "40%"}
            justifyContent="center"
            alignItems="center"
            display="flex"
            mb={isMobile ? 1 : 0}
            mt={isMobile ? 1 : 0}
          >
            <Box
              width={isMobile ? "75%" : "100%"}
              justifyContent="center"
              alignItems="center"
              display="flex"
            >
              <svg
                width="383"
                height="345"
                viewBox="0 0 383 345"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M191 2.5L1.5 344.5H381.5L191 2.5Z"
                  fill="#0E89BC"
                  stroke="black"
                />
                <path
                  d="M333.5 257.5H49.5L106.5 155H275.5L333.5 257.5Z"
                  fill="#D9D9D9"
                  stroke="black"
                />
                <path
                  d="M107 155L191 2L276 155H107Z"
                  fill="#ECECEC"
                  stroke="black"
                />
                <path
                  d="M142.9 304V287.15H145.075V302.175H152.275V304H142.9ZM164.15 298.35H155.65C155.7 301.325 157.6 302.55 159.8 302.55C161.375 302.55 162.325 302.275 163.15 301.925L163.525 303.5C162.75 303.85 161.425 304.25 159.5 304.25C155.775 304.25 153.55 301.8 153.55 298.15C153.55 294.5 155.7 291.625 159.225 291.625C163.175 291.625 164.225 295.1 164.225 297.325C164.225 297.775 164.175 298.125 164.15 298.35ZM155.675 296.775H162.1C162.125 295.375 161.525 293.2 159.05 293.2C156.825 293.2 155.85 295.25 155.675 296.775ZM165.6 291.9H167.95L170.325 298.7C170.725 299.8 171.05 300.8 171.3 301.8H171.375C171.65 300.8 172 299.8 172.4 298.7L174.75 291.9H177.05L172.3 304H170.2L165.6 291.9ZM188.767 298.35H180.267C180.317 301.325 182.217 302.55 184.417 302.55C185.992 302.55 186.942 302.275 187.767 301.925L188.142 303.5C187.367 303.85 186.042 304.25 184.117 304.25C180.392 304.25 178.167 301.8 178.167 298.15C178.167 294.5 180.317 291.625 183.842 291.625C187.792 291.625 188.842 295.1 188.842 297.325C188.842 297.775 188.792 298.125 188.767 298.35ZM180.292 296.775H186.717C186.742 295.375 186.142 293.2 183.667 293.2C181.442 293.2 180.467 295.25 180.292 296.775ZM191.716 304V286.25H193.916V304H191.716ZM207.297 304V289.8H207.247L204.422 291.325L203.997 289.65L207.547 287.75H209.422V304H207.297ZM220.914 287.475C224.339 287.475 226.289 290.525 226.289 295.7C226.289 301.225 224.239 304.275 220.639 304.275C217.464 304.275 215.314 301.3 215.264 295.925C215.264 290.475 217.614 287.475 220.914 287.475ZM220.789 289.175C218.864 289.175 217.464 291.525 217.464 295.95C217.464 300.175 218.764 302.575 220.764 302.575C223.014 302.575 224.089 299.95 224.089 295.8C224.089 291.8 223.064 289.175 220.789 289.175ZM233.882 287.475C237.307 287.475 239.257 290.525 239.257 295.7C239.257 301.225 237.207 304.275 233.607 304.275C230.432 304.275 228.282 301.3 228.232 295.925C228.232 290.475 230.582 287.475 233.882 287.475ZM233.757 289.175C231.832 289.175 230.432 291.525 230.432 295.95C230.432 300.175 231.732 302.575 233.732 302.575C235.982 302.575 237.057 299.95 237.057 295.8C237.057 291.8 236.032 289.175 233.757 289.175Z"
                  fill="white"
                />
                <path
                  d="M142.9 209V192.15H145.075V207.175H152.275V209H142.9ZM164.15 203.35H155.65C155.7 206.325 157.6 207.55 159.8 207.55C161.375 207.55 162.325 207.275 163.15 206.925L163.525 208.5C162.75 208.85 161.425 209.25 159.5 209.25C155.775 209.25 153.55 206.8 153.55 203.15C153.55 199.5 155.7 196.625 159.225 196.625C163.175 196.625 164.225 200.1 164.225 202.325C164.225 202.775 164.175 203.125 164.15 203.35ZM155.675 201.775H162.1C162.125 200.375 161.525 198.2 159.05 198.2C156.825 198.2 155.85 200.25 155.675 201.775ZM165.6 196.9H167.95L170.325 203.7C170.725 204.8 171.05 205.8 171.3 206.8H171.375C171.65 205.8 172 204.8 172.4 203.7L174.75 196.9H177.05L172.3 209H170.2L165.6 196.9ZM188.767 203.35H180.267C180.317 206.325 182.217 207.55 184.417 207.55C185.992 207.55 186.942 207.275 187.767 206.925L188.142 208.5C187.367 208.85 186.042 209.25 184.117 209.25C180.392 209.25 178.167 206.8 178.167 203.15C178.167 199.5 180.317 196.625 183.842 196.625C187.792 196.625 188.842 200.1 188.842 202.325C188.842 202.775 188.792 203.125 188.767 203.35ZM180.292 201.775H186.717C186.742 200.375 186.142 198.2 183.667 198.2C181.442 198.2 180.467 200.25 180.292 201.775ZM191.716 209V191.25H193.916V209H191.716ZM212.897 209H202.522V207.65L204.247 205.975C208.397 202.025 210.272 199.925 210.297 197.475C210.297 195.825 209.497 194.3 207.072 194.3C205.597 194.3 204.372 195.05 203.622 195.675L202.922 194.125C204.047 193.175 205.647 192.475 207.522 192.475C211.022 192.475 212.497 194.875 212.497 197.2C212.497 200.2 210.322 202.625 206.897 205.925L205.597 207.125V207.175H212.897V209ZM220.914 192.475C224.339 192.475 226.289 195.525 226.289 200.7C226.289 206.225 224.239 209.275 220.639 209.275C217.464 209.275 215.314 206.3 215.264 200.925C215.264 195.475 217.614 192.475 220.914 192.475ZM220.789 194.175C218.864 194.175 217.464 196.525 217.464 200.95C217.464 205.175 218.764 207.575 220.764 207.575C223.014 207.575 224.089 204.95 224.089 200.8C224.089 196.8 223.064 194.175 220.789 194.175ZM233.882 192.475C237.307 192.475 239.257 195.525 239.257 200.7C239.257 206.225 237.207 209.275 233.607 209.275C230.432 209.275 228.282 206.3 228.232 200.925C228.232 195.475 230.582 192.475 233.882 192.475ZM233.757 194.175C231.832 194.175 230.432 196.525 230.432 200.95C230.432 205.175 231.732 207.575 233.732 207.575C235.982 207.575 237.057 204.95 237.057 200.8C237.057 196.8 236.032 194.175 233.757 194.175Z"
                  fill="#BEBBBB"
                />
                <path
                  d="M142.9 124V107.15H145.075V122.175H152.275V124H142.9ZM164.15 118.35H155.65C155.7 121.325 157.6 122.55 159.8 122.55C161.375 122.55 162.325 122.275 163.15 121.925L163.525 123.5C162.75 123.85 161.425 124.25 159.5 124.25C155.775 124.25 153.55 121.8 153.55 118.15C153.55 114.5 155.7 111.625 159.225 111.625C163.175 111.625 164.225 115.1 164.225 117.325C164.225 117.775 164.175 118.125 164.15 118.35ZM155.675 116.775H162.1C162.125 115.375 161.525 113.2 159.05 113.2C156.825 113.2 155.85 115.25 155.675 116.775ZM165.6 111.9H167.95L170.325 118.7C170.725 119.8 171.05 120.8 171.3 121.8H171.375C171.65 120.8 172 119.8 172.4 118.7L174.75 111.9H177.05L172.3 124H170.2L165.6 111.9ZM188.767 118.35H180.267C180.317 121.325 182.217 122.55 184.417 122.55C185.992 122.55 186.942 122.275 187.767 121.925L188.142 123.5C187.367 123.85 186.042 124.25 184.117 124.25C180.392 124.25 178.167 121.8 178.167 118.15C178.167 114.5 180.317 111.625 183.842 111.625C187.792 111.625 188.842 115.1 188.842 117.325C188.842 117.775 188.792 118.125 188.767 118.35ZM180.292 116.775H186.717C186.742 115.375 186.142 113.2 183.667 113.2C181.442 113.2 180.467 115.25 180.292 116.775ZM191.716 124V106.25H193.916V124H191.716ZM202.447 123.175L203.047 121.475C203.672 121.875 205.122 122.5 206.647 122.5C209.472 122.5 210.347 120.7 210.322 119.35C210.297 117.075 208.247 116.1 206.122 116.1H204.897V114.45H206.122C207.722 114.45 209.747 113.625 209.747 111.7C209.747 110.4 208.922 109.25 206.897 109.25C205.597 109.25 204.347 109.825 203.647 110.325L203.072 108.725C203.922 108.1 205.572 107.475 207.322 107.475C210.522 107.475 211.972 109.375 211.972 111.35C211.972 113.025 210.972 114.45 208.972 115.175V115.225C210.972 115.625 212.597 117.125 212.597 119.4C212.597 122 210.572 124.275 206.672 124.275C204.847 124.275 203.247 123.7 202.447 123.175ZM220.914 107.475C224.339 107.475 226.289 110.525 226.289 115.7C226.289 121.225 224.239 124.275 220.639 124.275C217.464 124.275 215.314 121.3 215.264 115.925C215.264 110.475 217.614 107.475 220.914 107.475ZM220.789 109.175C218.864 109.175 217.464 111.525 217.464 115.95C217.464 120.175 218.764 122.575 220.764 122.575C223.014 122.575 224.089 119.95 224.089 115.8C224.089 111.8 223.064 109.175 220.789 109.175ZM233.882 107.475C237.307 107.475 239.257 110.525 239.257 115.7C239.257 121.225 237.207 124.275 233.607 124.275C230.432 124.275 228.282 121.3 228.232 115.925C228.232 110.475 230.582 107.475 233.882 107.475ZM233.757 109.175C231.832 109.175 230.432 111.525 230.432 115.95C230.432 120.175 231.732 122.575 233.732 122.575C235.982 122.575 237.057 119.95 237.057 115.8C237.057 111.8 236.032 109.175 233.757 109.175Z"
                  fill="#BEBBBB"
                />
              </svg>
            </Box>
          </Box>
        </Box>
        <Box pl={isMobile ? 0 : 8}>
          <Typography variant="h3" fontWeight={700}>
            {t("structureTitle")}
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection={isMobile ? "column" : "row"}
          mb={4}
          p={4}
          gap={2}
        >
          <Box
            width={isMobile ? "100%" : "50%"}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="flex-end"
            mt={isMobile ? 2 : 0}
          >
            <img
              src="progress_bar.png"
              alt="assessment"
              width={isMobile ? "100%" : "85%"}
            />
            <Typography variant="body1" color="textPrimary" mt={0} mb={0}>
              |
            </Typography>
            <Typography variant="body1" color="textPrimary" mt={0}>
              <b>{t("progressBar.title")}:</b> {t("progressBar.text")}
            </Typography>
          </Box>
          <Box
            width={isMobile ? "100%" : "50%"}
            justifyContent="flex-end"
            alignItems="center"
            flexDirection="column"
            display="flex"
            mt={isMobile ? 2 : 0}
          >
            <img src="timer.png" alt="assessment" width="20%" />
            <Typography variant="body1" color="textPrimary" mt={0} mb={0}>
              |
            </Typography>
            <Typography variant="body1" color="textPrimary" mt={0}>
              <b>{t("timer.title")}:</b> {t("timer.text")}
            </Typography>
          </Box>
        </Box>
        <Box
          display="flex"
          flexDirection={isMobile ? "column" : "row"}
          mt={2}
          mb={4}
          p={4}
          gap={2}
        >
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            flexDirection="column"
            width={isMobile ? "100%" : "50%"}
          >
            <img src="multiple_choice.png" alt="assessment" width="70%" />
            <Typography variant="body1" color="textPrimary" mt={0} mb={0}>
              |
            </Typography>
            <Typography variant="body1" color="textPrimary" mt={0}>
              <b>{t("multipleChoice.title")}:</b> {t("multipleChoice.text")}
            </Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            flexDirection="column"
            width={isMobile ? "100%" : "50%"}
          >
            <img src="true_false.png" alt="assessment" width="70%" />
            <Typography variant="body1" color="textPrimary" mt={0} mb={0}>
              |
            </Typography>
            <Typography variant="body1" color="textPrimary" mt={0}>
              <b>{t("trueFalse.title")}:</b> {t("trueFalse.text")}
            </Typography>
          </Box>
        </Box>
        <Box pl={isMobile ? 0 : 8} mb={3}>
          <Typography variant="body1" textAlign={isMobile ? "center" : "left"}>
            {t("goodLuck")}
          </Typography>
        </Box>
        <Box pl={isMobile ? 0 : 8} mb={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={handleCheckboxChange}
                color="secondary"
                sx={{ color: "black" }}
              />
            }
            label={t("acknowledgement")}
          />
        </Box>
        <Box
          display="flex"
          justifyContent={isMobile ? "center" : "flex-start"}
          mb={isMobile ? 4 : 6}
          pl={isMobile ? 0 : 8}
        >
          <Button
            variant="contained"
            color="primary"
            disabled={!isChecked}
            disableElevation
            onClick={onAssessmentBegin}
            size="large"
          >
            {t("beginButton")}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default StartAssessment;
